import { BitrixVue } from 'ui.vue3';

export const DiskUserFieldWidgetComponent = BitrixVue.defineAsyncComponent('disk.uploader.user-field-widget', 'UserFieldWidgetComponent');
